module.exports = __webpack_public_path__ + "img/es50_1.97be9fa6.png";